import {inject, injectable} from "inversify"
import ApiServiceType, {IApiService} from "../../interfaces/IApiService"
import {IMenuApi} from "../../interfaces/IMenuApi"

@injectable()
export class MenuApi implements IMenuApi {
	constructor(@inject(ApiServiceType.IApiService) private apiService: IApiService) {}

	getMenuByCustomer = async (customerId: string) => {
		const url = `/Menu?CustomerId=${customerId}`
		const {data} = await this.apiService.callApi(url, "POST")
		return data.Menu
	}
}
